import City_01 from "@/examples/city_01.json";
import City_autonomous from "@/examples/city-autonomous.json";
import B2CDemo from "@/examples/b2c_demo.json";
import B2C_2_Demo from "@/examples/b2c_2_demo.json";
import B2C_2_Demo_Test from "@/examples/b2c_2_demo_test.json";
import RemoteRider from "@/examples/ribot-01-m-08-remoterider.json";
import RemoteRiderMain from "@/examples/ribot-01-m-01-main.json";
import RemoteRiderMainTest from "@/examples/ribot-01-m-01-main-test.json";
import { Logger } from "./logger";
import CrossTheRoadShowcase from "@/examples/cross_the_road_showcase.json";
import CrossTheRoadWorkshop from "@/examples/cross_the_road_workshop.json";
import AnimasyonProjesiShowcase from "@/examples/animasyon_projesi_showcase.json";
import B2CShowcase from "@/examples/b2c_demo_2.json";
import JumpGameShowcase from "@/examples/jump_game_showcase.json";
import JumpGameM3Day from "@/examples/jump_game_m_3_da.json";
import ElectronicIntro from "@/examples/electronic_intro.json";
import ElbM9 from "@/examples/elb_m9.json";
import ElbM9Main from "@/examples/elb_m9_main.json";
import ElbM9Test from "@/examples/elb_m9_test.json";
import CurioFreetableMain from "@/examples/curio-freetable-main.json";
import CurioFreetableMainTest from "@/examples/curio-freetable-main-test.json";

const examples = {
	"city-01": City_01,
	"city-autonomous": City_autonomous,
	"b2c-demo": B2CDemo,
	"b2c-2-demo": B2C_2_Demo,
	"b2c-2-demo-test": B2C_2_Demo_Test,
	"ribot-01-m-08-remoterider": RemoteRider,
	"ribot-01-m-01-main": RemoteRiderMain,
	"ribot-01-m-01-main-test": RemoteRiderMainTest,
	"curio-freetable-main": CurioFreetableMain,
	"curio-freetable-main-test": CurioFreetableMainTest,
	"cross-the-road-workshop": CrossTheRoadWorkshop,
	"cross-the-road-showcase": CrossTheRoadShowcase,
	"b2c-demo-2": B2CShowcase,
	"animasyon-projesi-showcase": AnimasyonProjesiShowcase,
	"jump-game-m-3-da": JumpGameM3Day,
	"jump-game-showcase": JumpGameShowcase,
	"electronic-intro": ElectronicIntro,
	"elb-m9": ElbM9,
	"elb-m9-main": ElbM9Main,
	"elb-m9-test": ElbM9Test,
};

const getToken = () => {
	const path = window.location.pathname.split("/");
	return path[path.length - 1];
};

export const isPublicProject = () => {
	const token = getToken();
	return Object.keys(examples).includes(token);
};

export const getPublicProject = () => {
	const token = getToken();
	return examples[token as keyof typeof examples];
};
